import { Notify } from "notiflix";

Notify.init({
    position: 'center-center',
    distance: '50px',
    timeout: 2000,
});

const NOTIFY_INTERVAL = 60 * 60 * 1000; // 1 hour in milliseconds
const LAST_NOTIFY_TIME_KEY = 'lastNotifyTime';

export function checkNetworkType() {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection) {
        const type = connection.effectiveType;
        if (type !== '4g' && type !== '5g') {
            const now = Date.now();
            const lastNotifyTime = localStorage.getItem(LAST_NOTIFY_TIME_KEY);

            if (!lastNotifyTime || (now - lastNotifyTime) > NOTIFY_INTERVAL) {
                Notify.warning("Sinyal anda saat ini " + type + " mohon aktifkan mode pesawat");
                localStorage.setItem(LAST_NOTIFY_TIME_KEY, now);
            }
        }
    }
}

export function getNetworkType() {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return connection ? connection.effectiveType : null;
}

export async function isSlowNetwork() {
    const type = getNetworkType();
    
    if (type && (type === '2g' || type === '3g' || type === 'slow-2g')) {
        return true;
    }

    // For WiFi or unknown types, perform a speed test
    if (!type || type === 'wifi' || type === 'unknown') {
        try {
            const start = Date.now();
            const response = await fetch('https://www.google.com/favicon.ico', { method: 'HEAD', cache: 'no-cache' });
            const end = Date.now();
            const duration = end - start;
            // If response time > 2000ms, consider it slow
            if (duration > 2000) {
                return true;
            }
        } catch (error) {
            // If fetch fails, assume slow network
            return true;
        }
    }
    return false;
}

export async function checkNetworkBeforeSubmit() {
    const slow = await isSlowNetwork();
    if (slow) {
        Notify.warning("Sinyal anda lemah. Mohon aktifkan mode pesawat untuk melanjutkan submit.");
        return false; // Stop submit
    }
    return true; // Allow submit
}
